"use client";

import { memo } from "react";
import { Loader2 } from "lucide-react";
import equal from "fast-deep-equal";

interface BokehChartProps {
  data: string | { html?: string; json?: any };
  noBorder?: boolean;
}

function BokehChartComponent({ data, noBorder = false }: BokehChartProps) {
  // Extract HTML content from data
  const htmlContent = typeof data === "string" 
    ? data 
    : data.html || JSON.stringify(data);

  return (
    <div
      className={noBorder ? "w-full max-w-full" : "w-full max-w-full rounded-lg overflow-hidden bg-card border border-border"}
    >
      <div className="w-full h-full">
        <iframe
          srcDoc={htmlContent}
          className="w-full h-full"
          style={{ 
            width: "100%", 
            height: "600px", 
            border: "none",
            backgroundColor: "transparent"
          }}
          title="Bokeh Chart"
        />
      </div>
    </div>
  );
}

// Memoize with deep equality check to prevent re-renders when data hasn't changed
export const BokehChart = memo(BokehChartComponent, (prevProps, nextProps) => {
  return (
    equal(prevProps.data, nextProps.data) &&
    prevProps.noBorder === nextProps.noBorder
  );
});
